import { apiSlice } from '../api/apiSlice';
import { getUserProfile } from '../profile/profileSlice';
import { userLoggedIn } from './authSlice';

export const authApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		userLogin: builder.mutation({
			query: (data) => ({
				url: '/authentication-service/endpoint/oauth/login',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.result?.result === 'SUCCESS',
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;

					if (response?.data?.result?.result === 'SUCCESS') {
						localStorage.setItem('token', response?.data?.result?.authResponse?.id_token);
						localStorage.setItem('roleId', response?.data?.result?.roleList[0].id);
						localStorage.setItem('userId', response?.data?.result?.userId);
						localStorage.setItem('refreshToken', response?.data?.result?.authResponse?.refresh_token);
						localStorage.setItem('roleName', response?.data?.result?.roleList[0].name);

						//company name add company id added
						localStorage.setItem('companyCode', response?.data?.result?.companyCode);
						localStorage.setItem('companyName', response?.data?.result?.companyName);

						dispatch(
							userLoggedIn({
								accessToken: response.data.result.authResponse.id_token,
								refreshToken: response.data.result.authResponse.refresh_token,
								roleId: response.data.result.roleList[0].id,
								userId: response.data.result.userId,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		userLoginViaSSO: builder.mutation({
			query: (data) => ({
				url: '/authentication-service/endpoint/oauth/login-token',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.result?.result === 'SUCCESS',
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;

					if (response?.data?.result?.result === 'SUCCESS') {
						localStorage.setItem('token', response?.data?.result?.authResponse?.id_token);
						localStorage.setItem('roleId', response?.data?.result?.roleList[0].id);
						localStorage.setItem('userId', response?.data?.result?.userId);
						localStorage.setItem('refreshToken', response?.data?.result?.authResponse?.refresh_token);
						localStorage.setItem('roleName', response?.data?.result?.roleList[0].name);

						//company name add company id added
						localStorage.setItem('companyCode', response?.data?.result?.companyCode);
						localStorage.setItem('companyName', response?.data?.result?.companyName);

						dispatch(
							userLoggedIn({
								accessToken: response.data.result.authResponse.id_token,
								refreshToken: response.data.result.authResponse.refresh_token,
								roleId: response.data.result.roleList[0].id,
								userId: response.data.result.userId,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetProfile: builder.query({
			query: (userId) => ({
				url: `/authorization-service/endpoint/user/${userId}`,
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.result?.status === 'SUCCESS',
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const res = await queryFulfilled;

					dispatch(
						getUserProfile({
							profile: res.data.result.response[0],
						})
					);
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetSelfAuthorization: builder.query({
			query: () => ({
				url: '/authorization-service/endpoint/user/self',
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.result?.status === 'SUCCESS',
			}),
			providesTags: ['selfAuth'],
			keepUnusedDataFor: 5,
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const res = await queryFulfilled;

					dispatch(
						getUserProfile({
							profile: res.data.result.response[0],
						})
					);
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		getAccessPermission: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-email-verification',
				method: 'POST',
				body: data,
			}),
		}),
		getSubordinatesIds: builder.mutation({
			query: (data = {}) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-company-subordinates-ids',
				method: 'POST',
				body: data,
			}),
		}),
	}),
});

export const {
	useGetProfileQuery,
	useUserLoginMutation,
	useUserLoginViaSSOMutation,
	useGetSelfAuthorizationQuery,
	useGetAccessPermissionMutation,
	useGetSubordinatesIdsMutation,
} = authApi;
